import {Injectable} from '@angular/core';
import {AppService} from '../../../core/services/app.service';
import {HttpClient} from '@angular/common/http';
import {EventService} from '../../../core/services/event.service';

@Injectable({
    providedIn: 'root'
})
export class CategoryService extends EventService {
    private categoriesAPI = AppService.getApiUrl() + '/api/categories?filter[order]=name%20ASC';

    constructor(private http: HttpClient) {
        super();
    }

    getCategories(type?) {
        return this.http.get(this.categoriesAPI);
    }

}
